import type {
  GetInvestigationInsightsResponse,
  InsightsByState,
} from '@features/insight-findings/api/insight-findings.types';
import { InsightState } from '@features/investigations/utils/constants/index';

export const groupInsightsByState = (response: GetInvestigationInsightsResponse): InsightsByState =>
  response.content.reduce<InsightsByState>(
    (acc, insight) => {
      const key = insight.state.toLowerCase() as keyof InsightsByState;
      acc[key].push(insight);
      return acc;
    },
    {
      [InsightState.OPEN.toLowerCase()]: [],
      [InsightState.CLOSED.toLowerCase()]: [],
    } as unknown as InsightsByState,
  );
